import React from 'react'
import utester from 'style/images/check1st.svg';
import user1st from 'style/images/user1st.svg';
import styled from '@emotion/styled'

const StyleUser1stLogoContainer = styled.div`
    text-align: center;
    max-height: 10rem;
    padding-top: 1rem;
`;

const StyleUser1stLogo = styled.img`
    width: 9rem;
`;

const StyleUtesterLogoContainer = styled.div`
    text-align: left;
    padding: 2rem 0 1rem 0;
`;

const StyleUtesterLogo = styled.img`
    width: 10rem;
`;

export const UtesterLogo = () => (
    <StyleUtesterLogoContainer id="uTester-logo">
        <StyleUtesterLogo src={utester} alt='uTester logo'/>
    </StyleUtesterLogoContainer>
)

export const User1stLogo = () => (
    <StyleUser1stLogoContainer id="user1st-logo">
        <StyleUser1stLogo src={user1st} alt='user1st logo'/>
    </StyleUser1stLogoContainer>
)
